var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    fill: "#B8B8B8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0296 17.6259C36.7013 16.3376 35.7101 15.3251 34.4487 14.9885C32.1616 14.375 23 14.375 23 14.375C23 14.375 13.8384 14.375 11.5513 14.9885C10.2899 15.3251 9.29871 16.3376 8.97037 17.6259C8.375 19.9727 8.375 24.875 8.375 24.875C8.375 24.875 8.375 29.7773 8.97037 32.1241C9.29871 33.4124 10.2899 34.4249 11.5513 34.7615C13.8384 35.375 23 35.375 23 35.375C23 35.375 32.1616 35.375 34.4487 34.7615C35.7101 34.4249 36.7013 33.4124 37.0296 32.1241C37.625 29.7773 37.625 24.875 37.625 24.875C37.625 24.875 37.625 19.9727 37.0296 17.6259Z",
    fill: "#1F1F1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1875 29.6094V20.1406L28.4375 24.875L20.1875 29.6094Z",
    fill: "#B8B8B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.1e770452d766af2c75f0fc3bb9e004cb.svg";
export { ForwardRef as ReactComponent };